import { compositeKeyString } from "../util/panel";

export const generatePanelUrl = images => {
  if (images && images.size > 0) {
    var fls = [];
    for (const image of images) {
      fls.push(compositeKeyString(image));
    }
    return window.urls.panels + "?fl=" + fls.join(",");
  }
};

export const cleanPanelResponse = data => {
  const items = [];
  for (let fll of Object.values(data)) {
    const item = {
      product: fll.product,
      subProduct: fll.sub_product,
      geography: fll.geography,
      subGeography: fll.sub_geography,
      frameLists: []
    };
    for (let fl of fll.frame_lists) {
      const frameList = {
        id: fl.id,
        startValidity: fl.sv,
        endValidity: fl.ev,
        frames: []
      };
      for (let f of fl.frames) {
        const frame = {
          id: f.id,
          startValidity: f.sv,
          endValidity: f.ev,
          images: []
        };
        for (let i of f.images) {
          const image = {
            id: i.id,
            created: i.created
          };
          frame.images.push(image);
        }
        frameList.frames.push(frame);
      }
      item.frameLists.push(frameList);
    }
    items.push(item);
  }
  return items;
};
